import css from './line-list.css' assert { type: 'css' }
import { el } from '../../utils/dom-utils.js'

export class LineListView {
	constructor(shadowRoot, palette) {
		this.root = shadowRoot
		this.palette = palette

		const sheet = new CSSStyleSheet()
		sheet.replaceSync(css)
		this.root.adoptedStyleSheets = [sheet]
		this.root.innerHTML = /*html*/ `
			<div class="layout">
				<section class="panel" aria-labelledby="lefttitle">
					<h2 id="lefttitle">Liste ordonnée (dépose & insère)</h2>
					<div id="leftList" class="list" role="list"></div>
					<div class="hint">
						Fais glisser une carte. La ligne bleue indique l’<b>insertion</b> entre deux éléments.
						Glisse aussi pour <b>réordonner</b>.
					</div>
				</section>

				<section class="panel" aria-labelledby="righttitle">
					<h2 id="righttitle">Cartes mélangées</h2>
					<div id="pool" class="list" role="list" style="position:sticky;"></div>
					<div id="status" class="hint" aria-live="polite"></div>
					<div class="controls">
						<!-- <button id="checkBtn" class="action">Vérifier</button> -->
						<button id="resetBtn" class="action" style="background:#f59e0b;">Réinitialiser</button>
					</div>
				</section>
			</div>
		`

		this.leftList = this.root.querySelector('#leftList')
		this.pool = this.root.querySelector('#pool')
		this.statusEl = this.root.querySelector('#status')
		this.checkBtn = this.root.querySelector('#checkBtn')
		this.resetBtn = this.root.querySelector('#resetBtn')

		this.drag = { marker: null }
	}

	/** Efface les listes et le statut */
	clear() {
		this.leftList.innerHTML = ''
		this.pool.innerHTML = ''
		this.statusEl.textContent = ''
	}

	/**
	 * Rend les cartes mélangées à partir de l'ordre correct
	 * Chaque carte garde son id d’origine pour la vérification.
	 */
	renderItems(order) {
		// 1️⃣ Associer chaque texte à son index original
		const base = order.map((text, i) => ({ id: i, text }))

		// 2️⃣ Mélanger les objets (mais garder leur id)
		const mixed = [...base].sort(() => Math.random() - 0.5)

		// 3️⃣ Créer les éléments HTML
		const items = mixed.map((it, idx) => {
			const color = this.palette[idx % this.palette.length]
			const card = el('button', {
				class: 'item',
				type: 'button',
				role: 'listitem',
				tabindex: '0',
				// style: `background:${color}`,
				'data-id': String(it.id), // ✅ id d’origine
				'aria-grabbed': 'false',
			})
			card.textContent = it.text
			this.pool.append(card)
			return card
		})

		// Marqueur d’insertion partagé
		this.drag.marker = el('div', { class: 'marker', 'aria-hidden': 'true' })

		return items
	}
}
